import React from "react";
import SectionReveal from "./SectionReveal";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0A0A0A] py-28 sm:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid md:grid-cols-12 gap-10 md:gap-16">
        <SectionReveal className="md:col-span-5">
          <span className="block text-xs font-bold uppercase tracking-[0.3em] text-zinc-500 mb-6">
            03 — About
          </span>
          <h2
            className="text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.95] text-white"
            data-testid="about-headline"
          >
            Weaver
            <br />
            is:
          </h2>
        </SectionReveal>

        <SectionReveal className="md:col-span-7 md:pt-4" delay={0.15}>
          <p
            className="text-base sm:text-lg font-light text-zinc-300 tracking-wide leading-relaxed"
            data-testid="about-body"
          >
            Weaver Media is{" "}
            <em className="italic text-white font-medium not-italic-fallback">
              the
            </em>{" "}
            creative partner for your brand. Fifteen-plus years of international
            corporate media experience, distilled into boutique-grade craft —{" "}
            <span className="text-white font-medium">digital ads</span>,{" "}
            <span className="text-white font-medium">explainer animations</span>,{" "}
            <span className="text-white font-medium">
              hybrid animated mini-documentaries
            </span>
            , and{" "}
            <span className="text-white font-medium">sonic branding</span>.
          </p>
          <p className="mt-6 text-base sm:text-lg font-light text-zinc-400 tracking-wide leading-relaxed">
            We don&apos;t just produce content — we translate ideas into moving
            image and sound that lands with your audience, wherever they are.
            One piece or an ongoing partnership: Weaver delivers the quality of
            a major agency with the focus of a team personally invested in your
            win.
          </p>

          <div className="mt-12 grid sm:grid-cols-2 gap-6 sm:gap-8 border-t border-white/10 pt-8">
            {[
              "Digital Ads",
              "Explainer Animations",
              "Hybrid Animated Mini-Documentaries",
              "Sonic Branding",
            ].map((item) => (
              <div
                key={item}
                className="flex items-center gap-3"
                data-testid={`about-service-${item.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="w-6 h-px bg-white/40 shrink-0" />
                <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-zinc-200">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default About;
